<template>
  <div>
    <HeadNav
      :title="headNavImg.title"
      :titleEn="headNavImg.profiles"
      :src="headNavImg.picture"
      @clickType="getType"
    ></HeadNav>
    <div class="content">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <!-- <el-breadcrumb-item :to="{ path: '/news?value=02' }">新闻动态</el-breadcrumb-item> -->
        <el-breadcrumb-item><span @click="goBack()" class="newsTxt">新闻动态</span> </el-breadcrumb-item>
        <el-breadcrumb-item>{{this.newsDetail.title}}</el-breadcrumb-item>
      </el-breadcrumb>
      <div>
          <div class="title">{{this.newsDetail.title}}</div>
          <div class="title2">发布时间:{{getTime(this.newsDetail.releaseTime)}}</div>
          <div class="contentMobile" v-if="this.newsDetail.category==1" v-html='this.newsDetail.content'></div>
          <div class="video" v-if="this.newsDetail.category==2">
             <video width="300" muted autoplay controls>
	                <source :src="url+videoUrl" type="video/mp4" />
             </video>
          </div>
          
      </div>
    </div>
  </div>
</template>
<script>
import HeadNav from "../components/head.vue";
import { getNewsId, getTheme } from "../api/allApiRequest.js";
export default {
  name: "newsDetail",
  data() {
    return {
      url:'',
      videoUrl:'',
      headNavImg: {},
      value: 0,
      id: 0,
      newsDetail: {}
    };
  },
  components: {
    HeadNav
  },
  mounted() {
    this.url = process.env.VUE_APP_WEB_URL
    this.value = location.hash.split("?")[1]
      ? location.hash
          .split("?")[1]
          .split("&")[0]
          .split("=")[1]
      : 0;
    this.getThemeHead();
    this.id = location.hash.split("?")[1]
      ? location.hash
          .split("?")[1]
          .split("&")[1]
          .split("=")[1]
      : 0;
    this.getNewsDetail();
  },
  methods: {
    goBack(){
      this.$router.go(-1)
    },
    //主题返现
    getThemeHead() {
      getTheme({
        themeType: this.value
      }).then(res => {
        this.headNavImg = res.data.records[0];
        res.data.records[0].picture =
          process.env.VUE_APP_WEB_URL + res.data.records[0].picture;
      });
    },
    //根据ID搜索新闻详情
    getNewsDetail() {
      getNewsId({ id: this.id }).then(res => {
        // console.log(res);
        this.newsDetail = res.data;
        this.videoUrl = res.data.video
      });
      // console.log(this.url);
    },
    getTime(time){
       if(!time) return ''
       let month = time[1]>9 ? time[1] : '0' + time[1]
       let day   = time[2]>9 ? time[2] : '0' + time[2]
       let hour = time[3]>9 ? time[3] : '0' + time[3]
       let minute = time[4]>9 ? time[4] : '0' + time[4]
       return `${time[0]}-${month}-${day}  ${hour}:${minute}`
    }
  }
};
</script>
<style scoped>
.content {
  margin: 20px auto;
  width: 1190px;
}
div.title{
    text-align: center;
    font-size:24px;
    font-weight: bold;
    margin:20px 0 10px;
}
div.title2{
  text-align: center;
  font-size:16px;
}
.newsTxt{
  cursor: pointer;
  font-size: 16px;
}
.el-breadcrumb{
  font-size:16px!important;
}
.el-breadcrumb__separator{
    font-weight: 700!important;
}
.video {
  padding: 10px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media screen and (max-width: 750px){
  .content {
    margin: 0;
    width: 100%;
    box-sizing: border-box;
    padding: 20px 10px;
  }  
  .contentMobile img{
    max-width: 100%;
    min-width: 200px;
    height: auto;
  }
}
</style>